import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

import createSelectors from '~/hooks/stores/createSelectors'
import { CurrentCampaignGroup } from '~/types/campaigns'

export interface AccessGroupsStore {
  accessGroups: CurrentCampaignGroup[]
  canSendFullList: boolean
}

export const accessGroupsInitialState: AccessGroupsStore = {
  accessGroups: [],
  canSendFullList: false
}

const useAccessGroupsStoreBase = create<AccessGroupsStore>()(
  immer((set) => ({
    ...accessGroupsInitialState
  }))
)

const useAccessGroupsStore = createSelectors(useAccessGroupsStoreBase)

export default useAccessGroupsStore
